import { supabase } from "../supabaseClient";
console.log("🧠 Running upsertUserProfile...");

// ✅ Call this after user logs in or signs up
export const upsertUserProfile = async () => {
  try {
    const {
      data: { user },
      error: authError,
    } = await supabase.auth.getUser();

    if (authError || !user) {
      console.error("❌ Failed to get user from Supabase Auth:", authError?.message || "No user");
      return;
    }

    const uid = user.id;
    const email = user.email;

    // ✅ Check if user already exists in user_profiles
    const { data: existingUser, error: selectError } = await supabase
      .from("user_profiles")
      .select("*")
      .eq("id", uid)
      .single();

    if (selectError && selectError.code !== "PGRST116") {
      // PGRST116 = no rows found (which is fine for our use case)
      console.error("❌ Failed to check existing user:", selectError.message);
      return;
    }

    if (!existingUser) {
      // 🆕 New user – insert record
      const { error: insertError } = await supabase.from("user_profiles").insert({
        id: uid,
        email,
        resume_count: 0,
        last_login: new Date(),
      });

      if (insertError) {
        console.error("❌ Insert failed:", insertError.message);
      } else {
        console.log("✅ New user profile inserted");
      }
    } else {
      // 👋 Returning user – update last_login
      const { error: updateError } = await supabase
        .from("user_profiles")
        .update({ last_login: new Date() })
        .eq("id", uid);

      if (updateError) {
        console.error("❌ Update failed:", updateError.message);
      } else {
        console.log("👋 Returning user login updated");
      }
    }
  } catch (error) {
    console.error("🔥 Unexpected error in upsertUserProfile:", error.message);
  }
};
